function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.57141 4.21432H2.99998M2.99998 4.21432H14.4286M2.99998 4.21432V14.2143C2.99998 14.5932 3.15049 14.9566 3.4184 15.2245C3.68631 15.4924 4.04967 15.6429 4.42855 15.6429H11.5714C11.9503 15.6429 12.3137 15.4924 12.5816 15.2245C12.8495 14.9566 13 14.5932 13 14.2143V4.21432H2.99998ZM5.14284 4.21432V2.78575C5.14284 2.40687 5.29335 2.04351 5.56126 1.7756C5.82917 1.50769 6.19253 1.35718 6.57141 1.35718H9.42855C9.80743 1.35718 10.1708 1.50769 10.4387 1.7756C10.7066 2.04351 10.8571 2.40687 10.8571 2.78575V4.21432M6.57141 7.78575V12.0715M9.42855 7.78575V12.0715",
  stroke: "url(#paint0_linear)",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 2.05355,
  y1: 2.00949,
  x2: 10.8018,
  y2: 16.9936,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6CA00",
  stopOpacity: 0.94
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996888,
  stopColor: "#FF0000"
})));

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2306e51b.svg";
export { ForwardRef as ReactComponent };